'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPlaysid = exports.getValid = exports.formatTime = exports.addParam = exports.getVideoIdBySrc = exports.getVideoId = exports.safeThrow = exports.getVideoUrl = exports.CONSTS = undefined;

var _dom = require('./dom');

Object.keys(_dom).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _dom[key];
    }
  });
});

var _fullscreen = require('./fullscreen');

Object.keys(_fullscreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _fullscreen[key];
    }
  });
});

var _consts = require('./consts');

var _consts2 = _interopRequireDefault(_consts);

var _time = require('./time');

var _time2 = _interopRequireDefault(_time);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getVideoUrl(videoId, quality) {
  return '//cloud.video.alibaba.com/play/u/2153292369/p/1/e/6/t/1/d/' + (quality || 'hd') + '/' + videoId + '.mp4';
}

function getVideoId(elVideo) {
  var matches = elVideo.currentSrc.match(/\/(\d+)\.mp4($|\?|#)/);
  return matches && matches[1];
}

function getVideoIdBySrc(src) {
  var matches = src.match(/\/(\d+)\.mp4($|\?|#)/);
  return matches && matches[1];
}

function getPlaysid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    // eslint-disable-next-line no-bitwise
    var r = Math.random() * 16 | 0;
    // eslint-disable-next-line no-bitwise
    var v = c == 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}

function addParam(str) {
  for (var _len = arguments.length, others = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    others[_key - 1] = arguments[_key];
  }

  var params = others.filter(function (item) {
    return !!item;
  }).join('&');
  return str ? str + '&' + params : params;
}

function safeThrow(err) {
  setTimeout(function () {
    throw err;
  }, 0);
}

function getValid(num, min, max) {
  if (num < min) {
    return min;
  }
  if (num > max) {
    return max;
  }
  return num;
}

exports.CONSTS = _consts2['default'];
exports.getVideoUrl = getVideoUrl;
exports.safeThrow = safeThrow;
exports.getVideoId = getVideoId;
exports.getVideoIdBySrc = getVideoIdBySrc;
exports.addParam = addParam;
exports.formatTime = _time2['default'];
exports.getValid = getValid;
exports.getPlaysid = getPlaysid;